export const BillingRoute = {
  DASHBOARD: 'billing',
  PURCHASE_SUMMARY: 'purchase-summary'
};
